import _typeof from "@babel/runtime/helpers/typeof";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.match.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.array-buffer.slice.js";
import "core-js/modules/es.typed-array.uint8-array.js";
import "core-js/modules/es.typed-array.copy-within.js";
import "core-js/modules/es.typed-array.every.js";
import "core-js/modules/es.typed-array.fill.js";
import "core-js/modules/es.typed-array.filter.js";
import "core-js/modules/es.typed-array.find.js";
import "core-js/modules/es.typed-array.find-index.js";
import "core-js/modules/es.typed-array.for-each.js";
import "core-js/modules/es.typed-array.includes.js";
import "core-js/modules/es.typed-array.index-of.js";
import "core-js/modules/es.typed-array.iterator.js";
import "core-js/modules/es.typed-array.join.js";
import "core-js/modules/es.typed-array.last-index-of.js";
import "core-js/modules/es.typed-array.map.js";
import "core-js/modules/es.typed-array.reduce.js";
import "core-js/modules/es.typed-array.reduce-right.js";
import "core-js/modules/es.typed-array.reverse.js";
import "core-js/modules/es.typed-array.set.js";
import "core-js/modules/es.typed-array.slice.js";
import "core-js/modules/es.typed-array.some.js";
import "core-js/modules/es.typed-array.sort.js";
import "core-js/modules/es.typed-array.subarray.js";
import "core-js/modules/es.typed-array.to-locale-string.js";
import "core-js/modules/es.typed-array.to-string.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.object.assign.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.keys.js";
// 获取图片Element
export function loadImg(url, crossOrigin) {
  return new Promise(function (resolve) {
    var img = new Image();
    crossOrigin && img.setAttribute('crossOrigin', crossOrigin);
    img.src = url;
    img.onload = function () {
      resolve(img);
    };
  });
}

// base64转file
export function base64ToFile(dataurl) {
  var filename = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'image.png';
  if (!/^data/.test(dataurl)) {
    dataurl = "data:image/png;base64,".concat(dataurl);
  }
  var arr = dataurl.split(','),
    mime = arr[0].match(/:(.*?);/)[1],
    bstr = atob(arr[1]),
    n = bstr.length,
    u8arr = new Uint8Array(n);
  while (n--) {
    u8arr[n] = bstr.charCodeAt(n);
  }
  return new File([u8arr], filename, {
    type: mime
  });
}

// 验证base64的开头，并修正
export function validateBase64(dataurl) {
  if (!/^data/.test(dataurl)) {
    dataurl = "data:image/png;base64,".concat(dataurl);
  }
  return dataurl;
}

// 获取base64图片大小
export function getBase64ImageSize(src) {
  src = validateBase64(src);
  var base64 = src.split(",")[1].split("=")[0];
  var strLength = base64.length;
  var fileLength = strLength - strLength / 8 * 2;
  return Math.floor(fileLength);
}

// 缩略图转换
export function convertToThumb(src, options) {
  if (!src) return src;
  src = src.replace('/w.h/', '/');
  src = src.split('@')[0];
  if (typeof options === 'undefined') {
    options = {};
  }

  // 指定尺寸小于原图会裁剪，大于原图会返回原图，
  options = Object.assign({
    l: 1,
    e: 1,
    c: 1
  }, options);
  if (_typeof(options) === 'object') {
    // 腾讯 https://cloud.tencent.com/document/product/460/6929
    // 美大 https://wiki.maoyan.com/pages/viewpage.action?pageId=68986167
    if (src.match('pipi.cn')) {
      src = src.split('?')[0];
      var defaultE = 2;
      var eMapping = ['/2', '/3', '/1'];
      var qMapping = {
        q: '/rq/<Quality>',
        Q: '/q/<Quality>'
      };
      src += '?imageView2';
      src += options.c ? eMapping[defaultE] : eMapping[options.e] || eMapping[defaultE];
      options.w && (src += "/w/".concat(options.w));
      options.h && (src += "/h/".concat(options.h));
      if (options.q || options.Q) {
        var q = options.q ? 'q' : 'Q';
        src += qMapping[q].replace(/<Quality>/, options[q]);
      }
    } else {
      src += '@';
      src += Object.keys(options).filter(function (e) {
        return !!options[e];
      }).map(function (k) {
        return options[k] + k;
      }).join('_');
    }
  }
  return src;
}